import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { colors, sp } from 'styles/theme';

const propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const Wrapper = styled.div`
  margin-bottom: ${sp.m};
  &:last-child {
    margin: 0;
  }
`;

// prettier-ignore
const Title = styled.div`
  padding-bottom: ${sp.s};
  margin-bottom: ${sp.s};
  border-bottom: 1px solid ${colors.border};
  color: ${colors.cobalt};
  font-weight: 600;

  ${props => props.theme.vertical && css`
    font-size: 14px;
    border-bottom: 0;
    padding-bottom: 0;
  `}
`;

function Section({ title, children }) {
  return (
    <Wrapper>
      {/* <Title>{title}</Title> */}
      {children}
    </Wrapper>
  );
}

Section.propTypes = propTypes;

export default Section;



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/components/Section.jsx